module.exports = __webpack_public_path__ + "img/icon_map_61_on_011.b00eefbc.png";